
interface jpgProps {
  fill?: string
}

export function FindChildrenIcon (props: jpgProps): JSX.Element {
  const fill = props.fill ?? 'currentColor'
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2344_2143)">
      <path d="M12 12C13.5194 12 14.75 10.7694 14.75 9.25C14.75 7.73062 13.5194 6.5 12 6.5C10.4806 6.5 9.25 7.73062 9.25 9.25C9.25 10.7694 10.4806 12 12 12ZM12 13.375C10.1644 13.375 6.5 14.2962 6.5 16.125V17.5H17.5V16.125C17.5 14.2962 13.8356 13.375 12 13.375Z" fill={fill} />
    </g>
    <circle cx="11.625" cy="1.875" r="1.875" fill={fill} />
    <circle cx="22.125" cy="17.625" r="1.875" fill={fill} />
    <circle cx="1.875" cy="7.125" r="1.875" fill={fill} />
    <circle cx="1.875" cy="17.625" r="1.875" fill={fill} />
    <circle cx="22.125" cy="7.125" r="1.875" fill={fill} />
    <circle cx="11.625" cy="22.125" r="1.875" fill={fill} />
  </svg>
}
